module.exports = __webpack_public_path__ + "static/asperseur-gicleur-3c7fe4fc0d52b397e25dd3160c46ee81.mp4";